<template>
  <div
    class="modal fade"
    id="searchBranch"
    tabindex="-1"
    role="dialog"
    aria-labelledby="searchBranch"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">{{$t("bank.account.popup.branch_search")}}</h3>
        </div>
        <div class="modal-body">
          <div class="fieldset-cus">
            <form class="form-horizontal">
              <div class="form-group mb-0 overflow-auto">
                <label class="col-sm-4 control-label float-left mt-2">{{$t("bank.account.popup.search_branch_name")}}</label>
                <div class="col-sm-8 float-left">
                  <div class="input-group">
                    <input type="text" class="form-control input-bank" v-model="branchName">
                    <div class="input-group-btn">
                      <button class="btn btn-success btn-bank" @click.prevent="searchBranchFromPopup(true)">{{$t("btn.search")}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <table class="table table-striped table-bordered text-center table-hover table-responsive table-bank">
            <thead>
              <tr>
                <th class="text-center text-bank">{{$t("bank.account.popup.branch_code")}}</th>
                <th class="text-center text-bank">{{$t("bank.account.popup.branch_name")}}</th>
                <th class="text-center text-bank">{{$t("bank.account.popup.selection")}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in listBankBranch" :key="item.key">
                <td class="align-middle text-bank">{{item.id.branchCode}}</td>
                <td class="align-middle text-bank">{{item.branchName}}</td>
                <td style="width: 20%">
                  <button class="btn btn-info btn-bank" @click="selectBranch(item.id.branchCode, item.branchName)">
                    {{$t("bank.account.popup.selection")}}
                  </button>
                </td>
              </tr>
              <tr>
                <td colspan="3" class="nodata message-bank" v-if="listBankBranch == null || listBankBranch.length === 0">
                  {{$t(model.infoMessage)}}
                </td>
              </tr>
            </tbody>
          </table>
          <div align="center">
            <Pagination
              :total-pages="totalPage"
              :total="totalItems"
              :per-page="offset"
              :current-page="currentPage"
              @pagechanged="onPageChange"
              @pageJump="onPageJump"
              :previousText="$t('navigation.bt.previous')"
              :nextText="$t('navigation.bt.next')"
              :firstText="$t('navigation.bt.first')"
              :lastText="$t('navigation.bt.last')"
            ></Pagination>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary btn-bank" @click="hideWithConfirm()">{{$t("btn.close_windown")}}</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import ServiceUtils from "@/common/utils/ServiceUtils.js";
import Pagination from "@/components/base/Pagination.vue";
import $ from "jquery";

export default {
    name: "SearchBranch",
    components: {Pagination},
    data() {
        return {
            SERVICE_NAME: "bankAccount",
            model: {},
            branchName: null,
            bankCode: null,
            listBankBranch: [],

            totalPage: 0,
            totalItems: 0,
            offset: 0,
            currentPage: 1,
        }
    },
    mounted() {
        this.onOpenSearchBranchEvent();
        this.onCloseConfirmModal();
    },
    methods: {
        setPaginationInfo(pageNumber, offset, totalItems, totalPage, listItem) {
            this.currentPage = pageNumber;
            this.offset = offset;
            this.totalItems = totalItems;
            this.totalPage = totalItems === 0 ? 1 : totalPage;
            this.listBankBranch = listItem;
        },
        onOpenSearchBranchEvent() {
          ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.OPEN_SEARCH_BRANCH, (params) => {
                $('#searchBranch').modal({backdrop: 'static', keyboard: false});
                return this.show(params);
            });
        },
        onCloseConfirmModal() {
          ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_MODAL_CONFIRM + this.IConstants.E_CONFIRM_SCREEN.WITHDRAWAL_BRANCH, () => {
                this.hide();
            });
        },
        show(params) {
            $("#searchBranch").modal("show");
            this.model = params;
            this.bankCode = params.bankCode;
            this.setPaginationInfo(1, this.model.pagingInfo.offset, this.model.pagingInfo.total,
                this.model.pagingInfo.totalPage, this.model.listBankBranch);
        },
        searchBranchFromPopup(isBtnSearch) {
            let bankCode = this.bankCode;
            if (this.branchName) this.branchName = this.branchName.trim()
            let branchName = this.branchName;
            let branchNameFullSize = null;
            let branchNameHalfSize = null;
            if (branchName) {
                if (isBtnSearch) this.currentPage = 1;
                branchNameFullSize = ServiceUtils.convertHalfToFull(branchName);
                branchNameHalfSize = ServiceUtils.convertFullwidthToHalfwidthReturn(branchName);
                if (branchNameFullSize == null || typeof branchNameFullSize == "undefined") {
                    branchNameFullSize = "";
                }
                if (branchNameHalfSize == null || typeof branchNameHalfSize == "undefined") {
                    branchNameHalfSize = "";
                }
                if (branchName == null || typeof branchName == "undefined") {
                    branchName = "";
                }

                branchName = encodeURIComponent(encodeURIComponent(branchName));
                branchNameFullSize = encodeURIComponent(encodeURIComponent(branchNameFullSize));
                branchNameHalfSize = encodeURIComponent(encodeURIComponent(branchNameHalfSize));
            }

            const params = "index=" + this.currentPage +
                "&branchName=" + (branchName ? branchName : "") +
                "&bankCode=" + (bankCode ? bankCode : "") +
                "&branchNameFullSize=" + (branchNameFullSize ? branchNameFullSize : "") +
                "&branchNameHalfSize=" + (branchNameHalfSize ? branchNameHalfSize : "");

            this.$service.getService(this.SERVICE_NAME).searchBranchPopup(params).then((response) => {
                this.model = response;
                this.setPaginationInfo(this.currentPage, this.model.pagingInfo.offset, this.model.pagingInfo.total,
                    this.model.pagingInfo.totalPage, this.model.listBankBranch);
            });
        },
        onPageChange(page) {
            this.currentPage = page;
            this.searchBranchFromPopup(false);
        },
        onPageJump(page, previous, next, maxVisibleButtons) {
            this.currentPage = this.ServiceUtils.getCurrentPageOnPageJump(page, previous, next, maxVisibleButtons);
            this.searchBranchFromPopup(false);
        },
        selectBranch(branchCode, branchName) {
            const branchInfo = {
                branchCode: branchCode,
                branchName: branchName
            };
            this.$modal.afterSelectBranch(branchInfo);
            this.hide();
        },
        hide() {
            this.branchCode = null;
            this.branchName = null;
            $("#searchBranch").modal("hide");
        },
        hideWithConfirm() {
            const params = {messageText: this.$t("MSG_FCM_007")};
            this.$modal.modalConfirm(params, this.IConstants.E_CONFIRM_SCREEN.WITHDRAWAL_BRANCH);
        }
    },
}

</script>

<style scoped>
  .table-responsive {
    display: inline-table;
  }
  .modal-dialog {
    max-width: 600px;
  }
</style>
